if (!customElements.get('fsk-category-hub')) {
  customElements.define('fsk-category-hub', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      this.buttons = [...this.querySelectorAll('[data-hub-filter]')];
      this.items = [...this.querySelectorAll('[data-hub-group]')];
      this.grid = this.querySelector('.fskhub-grid');
      this.counter = this.querySelector('[data-hub-count]');
      this.heading = this.querySelector('[data-hub-heading]');
      this.directory = this.querySelector('.fskhub-directory');
      this.activeFilter = 'all';
      this.classList.add('is-ready');
      this.addEventListener('click', (event) => {
        const filter = event.target.closest('[data-hub-filter]');
        const pick = event.target.closest('[data-hub-pick]');
        if (!filter && !pick) return;
        const group = filter?.dataset.hubFilter || pick.dataset.hubPick;
        if (!this.buttons.some(button => button.dataset.hubFilter === group)) return;
        if (pick) event.preventDefault();
        this.applyFilter(group);
        if (pick) {
          this.heading.focus({ preventScroll: true });
          this.directory.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        }
      }, { signal: this.cleanup.signal });
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-hub-group]');
        if (item?.hidden) this.applyFilter('all');
      }, { signal: this.cleanup.signal });
    }
    disconnectedCallback() {
      this.cleanup?.abort();
      this.motion?.cancel();
    }
    applyFilter(group) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hubFilter === group)));
      this.items.forEach(item => { item.hidden = group !== 'all' && item.dataset.hubGroup !== group; });
      this.counter.textContent = String(this.items.filter(item => !item.hidden).length);
      if (group !== this.activeFilter && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.motion?.cancel();
        this.motion = this.grid.animate([{ opacity: 0.35, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 200, easing: 'ease-out' });
      }
      this.activeFilter = group;
    }
  });
}

